const REACT_APP_TRACE_BASE_URL = process.env.REACT_APP_TRACE_BASE_URL;
const fetchDataTrace = async ({ uri }: any) => {
  const response = await fetch(`${REACT_APP_TRACE_BASE_URL}/${uri}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  const result = await response.json();
  return result;
};

export default fetchDataTrace;
